module.exports = __webpack_public_path__ + "img/bg_sendmail.4d47f159.png";